import { render, staticRenderFns } from "./SessionTable.vue?vue&type=template&id=37058ba4&scoped=true&"
import script from "./SessionTable.vue?vue&type=script&lang=js&"
export * from "./SessionTable.vue?vue&type=script&lang=js&"
import style0 from "./SessionTable.vue?vue&type=style&index=0&id=37058ba4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37058ba4",
  null
  
)

export default component.exports